// extracted by mini-css-extract-plugin
export default {"solution":"NewHomeAssistant_solution__H-7ys","solution-wrapper":"NewHomeAssistant_solution-wrapper__EcDB5","solution-item":"NewHomeAssistant_solution-item__iFfr0"};